import React from 'react';
import { Check } from 'lucide-react';
import { Habit, DayEntry } from '../../types/habit';
import './HabitChips.scss';

interface HabitChipsProps {
  habits: Habit[];
  day: number;
  getEntry: (habitId: string, day: number) => DayEntry | undefined;
  onToggle: (habitId: string, day: number) => void;
  onRate: (habitId: string, day: number, rating: number) => void;
}

const HabitChips: React.FC<HabitChipsProps> = ({
  habits,
  day,
  getEntry,
  onToggle,
  onRate,
}) => {
  const checkboxHabits = habits.filter(h => h.type === 'checkbox');
  const ratingHabits = habits.filter(h => h.type === 'rating');

  return (
    <div className="habit-chips">
      <div className="habit-chips__row">
        {checkboxHabits.map(habit => {
          const entry = getEntry(habit.id, day);
          const done = entry?.completed === true;
          return (
            <button
              key={habit.id}
              className={`habit-chip${done ? ' habit-chip--done' : ''}`}
              style={{ '--chip-color': habit.color } as React.CSSProperties}
              onClick={() => onToggle(habit.id, day)}
              type="button"
            >
              <span className="habit-chip__icon">
                {done && <Check size={12} color="#fff" strokeWidth={3} />}
              </span>
              <span className="habit-chip__name">{habit.name}</span>
            </button>
          );
        })}

        {ratingHabits.map(habit => {
          const entry = getEntry(habit.id, day);
          const rating = entry?.rating ?? 0;
          return (
            <div
              key={habit.id}
              className={`habit-rating-group${rating > 0 ? ' habit-rating-group--done' : ''}`}
              style={{ '--chip-color': habit.color } as React.CSSProperties}
            >
              <span className="habit-rating-group__label">{habit.name}</span>
              <div className="habit-rating-group__dots">
                {[1, 2, 3, 4, 5].map(i => (
                  <button
                    key={i}
                    className={`habit-rating-group__dot${i <= rating ? ' habit-rating-group__dot--active' : ''}`}
                    style={i <= rating ? { '--dot-color': habit.color } as React.CSSProperties : undefined}
                    onClick={() => onRate(habit.id, day, rating === 1 && i === 1 ? 0 : i)}
                    type="button"
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HabitChips;
